

const doc = ['doc', 'docx', 'DOC', 'DOCX'];
const xls = ['xls', 'xlsx', 'XLS', 'XLSX'];
const ppt = ['ppt', 'pptx', 'PPT', 'PPTX'];
const pdt = ["pdf", 'PDF'];
const rar = ['rar', 'zip', 'tar', 'gz', '7z', 'bz2', 'cab', 'iso', 'RAR', 'ZIP', 'TAR', 'GZ', '7Z', 'BZ2', 'CAB', 'ISO'];
const txt = ['txt', 'TXT'];
const AUDIO = ["mp3","ogg","webm","wav","mid",'MP3','OGG','WEBM','WAV','MID']
export const uploadSetting = [{
     checkKey: AUDIO,
     val: 'icon_audio_path'
},
    {
        checkKey: doc,
        val: 'icon_word_path'
    },
    {
        checkKey: xls,
        val: 'icon_excel_path'
    },
    {
        checkKey: ppt,
        val: 'icon_ppt_path'
    }, {
        checkKey: pdt,
        val: 'icon_pdf_path'
    }, {
        checkKey: rar,
        val: 'icon_zip_path'
    }, {
        checkKey: txt,
        val: 'icon_txt_path'
    }
];

export const uploadType = [{
        name: 'picture',
        type: 1
    },
    {
        name: 'video',
        type:3
    },
    {
        name: 'audio',
        type:2
    }, {
        name: 'other_file',
        type:4
    }];

